"use strict";

const maska = require("maska");
const validator = require("validator");
const passwordComplexity = require('../../app/utils/password-complexity');

const errorModalTemplate = $.templates('#template-error-modal');
const $signupForm = $('.signupForm');

const showErrorModal = (message ='') => {
	const $modal = $(errorModalTemplate.render({ message }));

	$modal.modal();
	$modal.on('hidden.bs.modal', () => $modal.remove())
} 

const signalError = ($field, message) => {
	const field = $field[0];
	const $parent = $field.parents('.form-group');
	const $feedback = $parent.find('.invalid-feedback');

	$feedback.text(message);
	$field.addClass('is-invalid');
	
	field.setCustomValidity(message);

	return false;
};

const resetValidationState = ($field) => {
	const $parent = $field.parents('.form-group');
	const $feedback = $parent.find('.invalid-feedback');

	$feedback.text('');
	$field.removeClass('is-invalid');
	$field.removeClass('is-valid');
}

const validateDateOfBirth = ($dateOfBirthField) => {
	const pattern = /^(?<month>0?[1-9]|1[0-2])[\/|-](?<day>[0-2]?[1-9]|[1-3][01])[\/|-](?<year>\d{4})$/;
	const match = $dateOfBirthField.val().match(pattern);

	const dateError = (message) => signalError($dateOfBirthField, message);

	const $formatted = $dateOfBirthField.parent().find('#dob_hidden');

	$formatted.val('');

	const message = 'Please enter a valid date of birth that matches the format MM/DD/YYYY (e.g. 05/20/1989)';

	if (!match) {
		dateError(message);
		return;
	}

	const month = parseInt(match.groups.month);
	const day = parseInt(match.groups.day);
	const year = parseInt(match.groups.year);

	if (day === 0 | year === 0 | month === 0 || month > 12 || day > 31 || year < 1900) {	
		return dateError(message);
	}
	
	const dateObj = new Date(year, month - 1, day);

	// is the date entered in the future?
	if (dateObj > new Date()) {
		return dateError('Please enter a date that is not in the future.');
	};

	// did they enter an invalid day for the month? e.g., february 31st.
	if (dateObj.getMonth()+1 !== month) {
		return dateError('Please enter a valid month and day.');
	}

	$formatted.val(dateObj.toISOString());

	$dateOfBirthField.addClass('is-valid');
	return true;
};

const validateEmail = ($emailField) => {
	const email = $emailField.val().trim();

	if (!validator.isEmail(email)) {
		signalError($emailField, 'Please enter a valid email address.');
		return false;
	}

	$emailField.addClass('is-valid');

	return true;
}

const validatePassword = ($field, recurse = true) => {
	const password = $field.val();

	const $associatedField = $field.attr('id') === 'password' ? $('#password_confirm') : $("#password");

	// make sure there are no spaces
	if (password.indexOf(' ') > -1) {
		signalError($field, 'Please enter a password without spaces.');
	};

	if (!passwordComplexity(password)) {
		return signalError($field, 'Please enter a password that is at least 8 characters long');
	}

	if ($associatedField.val().length > 0 && $associatedField.val() !== password) {
	
		return signalError($field, 'Passwords do not match') || signalError($associatedField, 'Passwords do not match');
	}


	// this is basically clear the error state of the matching field if it a match error has been changed (match error on one forces an error state on the other)
	if ($associatedField.val() === password && recurse) {
		resetValidationState($associatedField);
		validatePassword($associatedField, false);
	}

	$field.addClass('is-valid');
	return true;
};

const validateName = ($field) => {
	const name = $field.val().trim();

	if (name.length < 1) {
		signalError($field, 'Please enter text with valid characters');
		return false;
	}

	$field.addClass('is-valid');
	return true;
}

// /(0?[1-9]|1[0-2])[\/|-]([0-2]?[1-9]|[1-3][01])[\/|-](\d{4})/
const dateOfBirthMask = maska.create('#dateOfBirth', {
	mask: ['##/##/####'],
});

$('.validateField').each((i, el) => {
	// attach validation function

	let validateFx;
	
	switch($(el).attr('id')) {
		case 'dateOfBirth':
			validateFx = validateDateOfBirth;
			break;
		case 'email':
			validateFx = validateEmail;
			break;
		case 'firstName':
		case 'lastName':
			validateFx = validateName;
			break;
		case 'password':
		case 'password_confirm':
			validateFx = validatePassword;
			break;
	}

	if (validateFx) {
		$(el).data('validateFx', validateFx);
		$(el).on('blur', e => validateFx($(el)))
			 .on('change', e => resetValidationState($(el)));
	
		// if the fields are pre-populated by a previous submission (that resulted in an error), validate them
		const value = $(el).val();
		if (value && value.length > 0) {
			$(el).data('validateFx')($(el));
		}
	}
});

const massValidate = () => {
	const failures = [];
	
	$('.validateField').each((i, el) => {
		if (typeof $(el).data('validateFx') === "function") {
			let outcome = $(el).data('validateFx')($(el));

			if (!outcome) {
				failures.push($(el));
			}
		}
	});

	return failures;
}

const handleSubmit = (event) => {
	const uncheckedAgreements = $('.reg:not(:checked)').length;
	const validationFailures = massValidate();
	const isValid = validationFailures.length === 0;
	const captchaCompleted = !captcha || grecaptcha.getResponse().length > 0;

	if ($('.btn-submit').hasClass('disabled') || !isValid || uncheckedAgreements > 0) {
		event.preventDefault();

		let message = '';

		
		if (!isValid) {
			const bullets = validationFailures.map((a) => `<li>${$(a).siblings('label').text()}</li>`);
			message += 'The following fields have validation errors:<br>';
			message += "<ul>";
			message += bullets.join("\n");
			message += "</ul>";
		}
		
		if (uncheckedAgreements > 0 || !captchaCompleted) {
			
			if (!isValid) {
				message += "<hr>Additionally, the following errors have occured:";
			}
			message += '<ul>';
			if (uncheckedAgreements > 0) {
				message += '<li>You must accept the agreements to continue.</li>';
			}
			
			if (!captchaCompleted) {
				message += '<li>Please verify that you are not a robot by completing the CAPTCHA challenge.</li>';
			}
			message += '</ul>';
		}
		if (message) {
			showErrorModal(message)
		}
		
		return;
	}

	
	let proposedDate = new Date($('#dob_hidden').val())
	if (proposedDate == 'Invalid Date') {
		alert("Please enter a valid date of birth");
		return;
	}

	if ((new Date() - proposedDate)/1000 < 94672800) {
		if (!confirm(`Please confirm that your date of birth is ${moment(proposedDate).format("MMMM D, YYYY")}\n\nPress 'Ok' to continue or 'Cancel' to modify.`)) {
			event.preventDefault();
			return;
		}
	}
}



$signupForm.on('submit', (event) => handleSubmit(event));


$(".btn-submit").on("click", () => $("form").trigger('submit'));

$('input').on('keyup', (event) => {
	if (event.key != "Enter") { 
		// terminate if not enter button
		return;
	}
	// handle submit here, but first make sure that *THIS* field passes validation. If so, then proceed with form submit (which does a mass validation)
	const $field = $(event.target);
	const validateFx = $field.data('validateFx');

	if (validateFx && typeof validateFx === 'function') {
		if (validateFx($field)) {
			$signupForm.trigger('submit')
		} else {
			return;
		}
	} else {
		// no validation on this field, so just proceed with submit.
		$signupForm.trigger('submit');
	}

})

if (captcha) {
	$('.btn-submit').addClass('disabled');
}

setTimeout(() => $(".successMsg").fadeOut(), 5500);